import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  agencies: [], // Initial data
};

export const agencySlice = createSlice({
  name: 'agencyUser',
  initialState,
  reducers: {
    addAgency: (state, action) => {
      state.agencies.push(action.payload);
    },

    setAgencies: (state, action) => {
      state.agencies = action.payload;
    },
    removeAgency: (state, action) => {
      state.agencies = state.agencies.filter(
        agency => agency._id !== action.payload, // Use _id for filtering
      );
    },
    updateAgency: (state, action) => {
      const index = state.agencies.findIndex(
        agency => agency._id === action.payload._id, // Match by _id
      );
      if (index !== -1) {
        state.agencies[index] = action.payload;
      }
    },
    loadAgencies: (state, action) => {
      state.agencies = action.payload;
    },
  },
});

export const {
  addAgency,
  removeAgency,
  updateAgency,
  loadAgencies,
  setAgencies,
} = agencySlice.actions;
export default agencySlice.reducer;
